import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

export function ArchetypeCard({ archetype }) {
  if (!archetype) return null;
  const pct = archetype.confidence != null ? Math.round(archetype.confidence * 100) : null;
  return (
    <Card className="bg-white/90 shadow-card" data-testid="journey-archetype-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-primary" />
          Archetype
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        <p className="font-heading text-xl">{archetype.name}</p>
        {archetype.essence && <p className="text-muted-foreground italic">&ldquo;{archetype.essence}&rdquo;</p>}
        {pct != null && <Badge variant="secondary">{pct}% match</Badge>}
      </CardContent>
    </Card>
  );
}
